import React from 'react';

const Services = () => {
  const services = [
    {
      title: "Remodelações",
      description: "Transformamos espaços com soluções modernas, atenção ao detalhe e respeito pela estrutura existente, para dar nova vida ao seu imóvel."
    },
    {
      title: "Pinturas",
      description: "Pintura profissional de interiores e exteriores, com acabamentos duradouros e materiais de alta qualidade, garantindo um resultado impecável."
    },
    {
      title: "Reparações e Manutenção",
      description: "Serviços rápidos e eficazes de reparação e manutenção em habitações e espaços comerciais, com foco na qualidade, segurança e confiança."
    },
    {
      title: "Reabilitação de Fachadas e Terraços",
      description: "Intervenções especializadas para restaurar, proteger e valorizar fachadas e terraços, melhorando a durabilidade, estética e impermeabilização dos edifícios."
    }
  ];

  return (
    <section id="servicos" className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center mb-12">Nossos Serviços</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold mb-4">{service.title}</h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;